const sh =
  "bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] rounded animate-pulse";

export const TicketDescriptionShimmer = () => (
  <div className="flex-1 min-h-0 flex flex-col min-w-0 p-4">
    <div className="flex-1 basis-0 min-h-[120px] flex flex-col rounded-lg bg-pure-white dark:bg-pure-white-dk overflow-hidden">
      <div className="flex items-center gap-2 px-3 py-2.5 border-b border-border-gray dark:border-border-gray-dk">
        {[18, 18, 18, 18, 18, 18, 18].map((w, i) => (
          <div
            key={i}
            className={`h-[18px] rounded ${sh}`}
            style={{ width: w }}
          />
        ))}
      </div>

      <div className="flex flex-col gap-5 p-4">
        <div className="flex flex-col gap-1">
          <div className={`h-[14px] w-[40%] ${sh}`} />
          <div className={`h-[14px] w-[25%] ${sh}`} />
        </div>
        <div className={`h-[14px] w-[30%] ${sh}`} />
        <div className={`h-[14px] w-[35%] ${sh}`} />
        <div className="flex flex-col gap-1">
          <div className={`h-[14px] w-full ${sh}`} />
          <div className={`h-[14px] w-[92%] ${sh}`} />
          <div className={`h-[14px] w-[85%] ${sh}`} />
          <div className={`h-[14px] w-[60%] ${sh}`} />
        </div>
        <div className="flex flex-col gap-1">
          <div className={`h-[14px] w-full ${sh}`} />
          <div className={`h-[14px] w-[88%] ${sh}`} />
          <div className={`h-[14px] w-3/4 ${sh}`} />
        </div>
      </div>
    </div>
  </div>
);
